<template>
  <div class="col-3">
    <!-- Item post -->
    <div>
      <router-link :to="`/${slug}`" class="wrap-pic-w hov1 trans-03">
        <img :src="entertainmentImage" alt="entertainment" />
      </router-link>

      <div class="p-t-10">
        <h5 class="p-b-5">
          <router-link :to="`/${slug}`" class="f1-s-5 cl3 hov-cl10 trans-03">
            {{ title }}
          </router-link>
        </h5>

        <span class="cl8">
          <router-link :to="`/${slug}`" class="f1-s-6 cl8 hov-cl10 trans-03"> {{ category }} </router-link>

          <span class="f1-s-3 m-rl-3"> - </span>

          <span class="f1-s-3"> {{ dateCreated }} </span>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    entertainmentImage: {
      type: String,
      default: 'images/post-50.jpg'
    },
    title: {
      type: String,
      default: 'Donec metus orci, malesuada et lectus'
    },
    category: {
      type: String,
      default: 'Entertainment'
    },
    dateCreated: {
      type: String,
      default: 'Feb 18'
    },
    slug: {
      type: String,
      defaullt: ''
    }
  }
}
</script>
